import type { App } from 'vue'
import {
  CHAVE_OPERACOES_CATALOGO_REGRA_DE_CALCULO,
} from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/apresentacao/catalogo-regra-de-calculo.injecao'
import type {
  OperacoesCatalogoRegraDeCalculo,
} from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/catalogo-regra-de-calculo.tipos'
import {
  ListarOpcoesRegraDeCalculoRepositorioHttp,
} from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/listar-opcoes/listar-opcoes-regra-de-calculo.repositorio-http'

import type { InfraestruturaAplicacao } from '../criar-infraestrutura'

export const comporCatalogoRegraDeCalculo = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoRegraDeCalculo => {
  const repositorio = new ListarOpcoesRegraDeCalculoRepositorioHttp(
    infraestrutura.httpCondominio,
  )
  return {
    listarOpcoes: repositorio.executar,
  }
}

export const instalarRegraDeCalculo = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
): void => {
  app.provide(
    CHAVE_OPERACOES_CATALOGO_REGRA_DE_CALCULO,
    comporCatalogoRegraDeCalculo(infraestrutura),
  )
}
